import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useTheme } from 'styled-components';
import { Button } from '../../Controls/Button/index.js';
import Icons from '../../Elements/Icons/index.js';
import { Loader } from '../../Elements/Loader/index.js';
import { Placeholder } from './styled.js';
export const FileStateIcon = memo(function FileStateIcon({ error, isUploading, onReset, progressVisible, success, tryAnotherText, }) {
    const theme = useTheme();
    if (isUploading && !progressVisible) {
        return _jsx(Loader, {});
    }
    if (success) {
        return _jsx(Icons.Check, { filled: true, color: theme.colors.positive100 });
    }
    if (error) {
        return (_jsxs(_Fragment, { children: [_jsx(Icons.Warning, { filled: true, color: theme.colors.critical100 }), _jsx(Button, { ghost: true, onClick: onReset, children: tryAnotherText })] }));
    }
    return _jsx(Placeholder, {});
});
